import get from 'lodash/get';
import orderBy from 'lodash/orderBy';
import { useMemo } from 'react';

import type WithSortingRules from '@sravni/vitrina/lib/types/config/common/WithSortingRules';
import type ISortingOptionsConfig from '@sravni/vitrina/lib/types/config/ISortingOptionsConfig';
import type IProduct from '@sravni/vitrina/lib/types/IProduct';

import type ITabDetail from '../../interfaces/ITabDetail';

export const useRows = (product: IProduct, config: ITabDetail) =>
  useMemo((): Array<Record<string, any>> => {
    const tableRows = Object.values(product[config.table.tableName]);

    if (!config.sorting) {
      return tableRows;
    }

    return orderBy(
      tableRows,
      [...getRules(config.sorting), ...config.sorting.properties],
      [...(config.sorting?.rules || []).map((rule) => rule.direction), ...config.sorting.directions],
    );
  }, [product, config]);

function getRules(sortingConfig: WithSortingRules<ISortingOptionsConfig>) {
  if (!sortingConfig?.rules) {
    return [];
  }

  return sortingConfig.rules.map((rule) => (item: Record<string, string | number | string[]>) => {
    const value = get(item, rule.property);

    if (Array.isArray(value)) {
      return Math.min(...value.map((x) => getIndex(rule, x)));
    }

    return getIndex(rule, value);
  });
}

function getIndex(rule: { values: Array<string | number> }, value: string | number) {
  return rule.values.indexOf(value) + 1 || Number.POSITIVE_INFINITY;
}
